import { appApiUrl, appBaseUrl, appBaseName, appAdminModuleName } from "../config/appConfig";
export const apiUrl = appApiUrl;
export const baseUrl = appBaseUrl;
export const baseName = appBaseName;
export const adminModuleName = appAdminModuleName;

